import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import WaInboxContactDetails from "./WaInboxContactDetails";
import "./WhatsAppInbox.css";
import WhatsAppInboxChatPanel from "./WhatsAppInboxChatPanel";
import WhatsAppInboxSIdebar from "./WhatsAppInboxSIdebar";

const WhatsAppInbox = () => {
  const [selectedChat, setSelectedChat] = useState({
    id: 1,
    name: "KK",
    initials: "K",
    lastMessage: "Cc",
    time: "1 min",
    subtitle: "Kusha...",
    unread: false,
    online: true,
  });
  const [showContactDetails, setShowContactDetails] = useState(true);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [isTabletView, setIsTabletView] = useState(
    window.innerWidth >= 768 && window.innerWidth < 992,
  );

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobileView(width < 768);
      setIsTabletView(width >= 768 && width < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChatSelect = (chat) => {
    setSelectedChat(chat);
  };

  const handleBackToList = () => {
    setSelectedChat(null);
    setShowContactDetails(true);
  };

  const toggleContactDetails = () => {
    if (isMobileView || isTabletView) {
      setShowContactDetails(!showContactDetails);
    }
  };

  return (
    <Container fluid className="whatsapp-inbox-wrapper p-0">
      <Row className="h-100">
        {/* Sidebar - Conversation List */}
        {(!isMobileView || !selectedChat) && (
          <Col xs={12} md={4} lg={3} className="conversation-sidebar pe-0">
            <WhatsAppInboxSIdebar onChatSelect={handleChatSelect} selectedChat={selectedChat} />
          </Col>
        )}

        {/* Chat Area */}
        {(!isMobileView || (selectedChat && !showContactDetails)) && selectedChat && (
          <Col
            xs={12}
            md={showContactDetails && !isMobileView && !isTabletView ? 5 : 8}
            lg={showContactDetails && !isMobileView && !isTabletView ? 6 : 9}
            className="chat-area-wrapper ps-0"
          >
            <WhatsAppInboxChatPanel
              selectedChat={selectedChat}
              onBack={handleBackToList}
              onToggleDetails={toggleContactDetails}
              isMobileView={isMobileView}
            />
          </Col>
        )}

        {/* Contact Details */}
        {selectedChat && (
          <>
            {!isMobileView && !isTabletView && (
              <Col md={3} lg={3} className="contact-details-wrapper">
                <WaInboxContactDetails
                  selectedChat={selectedChat}
                  onClose={toggleContactDetails}
                  isMobileView={false}
                />
              </Col>
            )}

            {(isMobileView || isTabletView) && showContactDetails && (
              <Col xs={12} className="contact-details-fullscreen">
                <WaInboxContactDetails
                  selectedChat={selectedChat}
                  onClose={toggleContactDetails}
                  isMobileView={true}
                />
              </Col>
            )}
          </>
        )}
      </Row>
    </Container>
  );
};

export default WhatsAppInbox;
